import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";

import Instructor1 from "../../../../../assets/images/png/courses/instructors/trainers pictures/PRINCEWILL SUIT - AI Automation Practice Lead.png";
import OmobosolaImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/OMOBOSOLA SUIT - Product & Digital Marketing and AI Automation Support Person.png";
import RachaelImage from "../../../../../assets/images/png/courses/instructors/rachael.webp";
import DoluImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/Ayotunde1.webp";
import FaithImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/FAITH Customer Success Manager.png";

import PortfolioImage from "../../../../../assets/images/png/courses/portfolio/product.webp";

import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";
import FrontendPreview from "../../../../../assets/images/jpeg/softwarePreview.jpeg";

export const frontendProgrammingAfrica = {
  id: 1,
  tag: "For Starters",
  title: "Frontend Development Bootcamp",
  seoTitle: "Frontend Development Bootcamp",
  description: `
  Go from zero knowledge to being able to build your technology platforms! Starting with 
  the foundations of software engineering. By the end of this program you would 
  have mastered a specialization and learn the art of effective collaboration 
  to solve real world problems.
    `,
  duration: "2 Months",

  downloadBrochureUrl:
    "https://drive.google.com/file/d/17OuBsJwlCd3fdgejysstLpSKUE_8MlIB/view?usp=sharing",

  courseFormUrl: "courses/frontend-development/fill-form",

  jobTitle: "Frontend Developer",

  kickoffDate: "December 2",
  kickoffTime: (
    <>
      Friday 4:00 PM - 7:00 PM WAT
      <br />
      Saturday 10:00 AM - 1:00 PM WAT
      <br />
      Sunday 2:00 PM - 5:00 PM WAT
    </>
  ),

  testimonial: {
    // image: TestimonialImage,
    name: "Abayomi O.",
    role: "Frontend Developer",
    testimony: `
    I was looking for something a little more than a training, a school I 
    could count on for my continuous skill and professional development. 
    Utiva kept coming up so I jumped in. I went through the Development
    program. `,
    starRating: "5.0",
    date: "August 2021",
  },

  courseOverview: {
    title: `Learn Frontend Software Development Live, Led by Experienced Software Engineers.`,
    desc: `
    This course is designed for an absolute beginner. It is the most comprehensive, 
    A to Z web design, web development and career-building course that will kickstart 
    your progress by focusing on what you need to learn, and avoiding the unnecessary 
    details. Whether you are total beginner looking for a full packaged frontend development program, 
    or you are programmer/web developer looking to improve your design skills, or maybe a designer 
    looking to learn how to code, this course takes you step-by-step through all of the 
    necessary skills you need to know to start working professionally as a web designer or developer.
    `,
  },

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Web Development Fundamentals",
      unitTag: "HTML, CSS, Flexbox",
      unitDescription: `
      Learn to structure code in a concise, logical, and readable manner, 
      while mastering HTML and CSS, two foundational front-end languages. 
      Create static web pages using HTML and CSS alone, before applying 
      Flexbox (a CSS framework) to increase the complexity and speed in which you create your web pages.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Understanding Fundamentals",
          featureDescription: `Use your new skills to create a professional website that is responsive to both mobile 
              and computer browsers. Your work will be expanded later in the program.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Transition",
          featureDescription: `You will augment your previously developed static site by adding multiple 
              pages with underlying logic to create basic interactive features.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Visualization",
          featureDescription: `Using React, you’ll create a professional single page application, 
              which leverages complex functionality and visual styling.`,
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "JavaScript",
      unitTag: "Functions, Animations, Components",
      unitDescription: `
      Sites today don’t just display content – they are interactive, 
      with animations, logins, checkouts, and much more. To add functionality 
      to your websites, you will learn the essentials of object-oriented programming 
      and JavaScript, including how to leverage reusable "building blocks" of code.
        You will then build on these programming fundamentals by learning 
        how to create and implement functions and animations.

        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Understanding Fundamentals",
          featureDescription: `Use your new skills to create a professional website that is responsive to both mobile 
              and computer browsers. Your work will be expanded later in the program.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Transition",
          featureDescription: `You will augment your previously developed static site by adding multiple 
              pages with underlying logic to create basic interactive features.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Visualization",
          featureDescription: `Using React, you’ll create a professional single page application, 
              which leverages complex functionality and visual styling.`,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "React",
      unitTag: "Components, States, APIs",
      unitDescription: `
      Leverage React, one of the most popular JavaScript frameworks, 
      to refine the quality of your work and create professional user interfaces. 
      You’ll learn to manage states, allowing your website to work with data 
      in a more dynamic way; and integrate an application programming interface 
      (API), which connects your website to a back-end.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Understanding Fundamentals",
          featureDescription: `Use your new skills to create a professional website that is responsive to both mobile 
          and computer browsers. Your work will be expanded later in the program.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Transition",
          featureDescription: `You will augment your previously developed static site by adding multiple 
          pages with underlying logic to create basic interactive features.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Visualization",
          featureDescription: `Using React, you’ll create a professional single page application, 
          which leverages complex functionality and visual styling.`,
        },
      ],
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Princewill Ogbu",
      coachRole: "AI Automation Practice Lead",
    },
    {
      coachId: 2,
      coachImage: RachaelImage,
      coachName: "Rachael Wilson",
      coachRole: "Senior Data Analyst",
    },
    {
      coachId: 3,
      coachImage: DoluImage,
      coachName: "Doluwamu Ayotunde Solana",
      coachRole: "Senior Data Scientist",
    },
    {
      coachId: 4,
      coachImage: FaithImage,
      coachName: "Faith",
      coachRole: "Customer Success Manager",
    },
    {
      coachId: 5,
      coachImage: OmobosolaImage,
      coachName: "Omobosola Olafimihan",
      coachRole: "AI Automation Support",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "Learning Model",
      modelDescription:
        "A 8 Weeks experiential learning and hands-on training session.",
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Training Methodology",
      modelDescription: "Learn through real-life problems",
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Business Case-Focused",
      modelDescription:
        "Work on real-life projects by applying what you learn to solve related business problems.",
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "Access Contents & Materials",
      modelDescription: "50% on your own + 50% in live classes",
    },
  ],

  studentTestimonies: [
    {
      id: 1,
      linkedIn: "",
      image: null,
      firstname: "Abayomi",
      lastname: "O.",
      company: "Frontend Dev Fellow",
      testimony: `
      Utiva has impacted my career progression in a 
      positive way as the changes in the last couple of months have 
      been rapid. I've had to change roles from a business-oriented role 
      to a digital-oriented role. I've had opportunities to implement 
      my learnings in real life scenarios, had a role change to a developer role, scholarships 
      and also volunteering roles. I feel fulfilled implementing my passion.  
      `,
    },
  ],

  portofolio: {
    title: "Build Solutions around Real-life Business Cases ",
    description: `
    Present everything you've learned with a real-world capstone project. 
    Every week in your frontend development classes, you'll be provided 
    with clear actionable steps to iteratively develop your project. 
    By the end of the course, you will have implemented each step of 
    the process, leveraging your knowledge of HTML, CSS, Javascript and ReactJS
    to develop and derive a comprehensive solution of your work.
      `,

    name: "Olatunji Abayomi",
    // image: PortfolioUserAvatar,
    portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Frontend Development Certification",
    description: `
    Upon completing Utiva's Frontend Development Course, you'll 
    receive an industry-recognized, professional Frontend Development 
    certification to share with your network and showcase all that 
    you've learned. Utiva certificates are formatted for sharing on LinkedIn.
      `,
  },

  // videoTestimonial: "https://youtu.be/TQrD6jyYqxs",
  videoTestimonial: "https://www.youtube.com/embed/ArxnT-7wAg4",
  videoPreviewImage: FrontendPreview,

  otherCourses: [
    {
      id: 1,
      courseTitle: "Become a Full-Stack Developer",
      courseDescription: `Go from zero knowledge to being able to build your technology platforms! Starting with 
      the foundations of software engineering. By the end of this program you 
      would have mastered a specialisation and learn the art of effective 
      collaboration to solve real world problems.`,
      courseUrl: "/courses/fullstack-development",
    },
    {
      id: 2,
      courseTitle: "Become a Backend Developer",
      courseDescription: `Go from zero knowledge to being able to build your own complete 
      websites! Starting with the foundations of software engineering. 
      Develop and deploy enterprise back-end applications following best practices using Express JS & NodeJS.`,
      courseUrl: "/courses/backend-development",
    },
  ],
};
